import React, { useCallback, useEffect, useState } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV, fetchDataCallOnInitialLoad } from "../../../../common_nextgen/utils/UtilFunctions";

const useSelectMessage = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialLookupType,
  selectModeParamData = null
) => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({
    searchCriteria: selectModeParamData?.code ?? "",
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [isFrescheJump, setIsFrescheJump] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const screen_title = "Select Message";
  const screenNumber = "RCMSG002";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "MSG Message Cde",
      name: "searchCriteria",
      label: "Message Code",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = useCallback(() => {
    if (lookupType === "external") {
      const message = {
        type: "hideModal",
      };
      window.parent.postMessage(message, "*");
    } else {
      hideModal();
    }
  }, [hideModal, lookupType]);

  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    // // {
    // //   button_label: "Add Select Message",
    // //   button_handeler: () => {
    // //     navigateToPage(ADD_PRICE_SCHEDULE);
    // //   },
    // //   button_key: "F6",
    // // },
    // // {
    // //   button_label: "Export as CSV",
    // //   button_handeler: () => {
    // //     exportAsCSV();
    // //   },
    // //   button_key: "",
    // // },
    // // {
    // //   button_label: "Back",
    // //   button_handeler: () => {
    // //     navigateToPage(DISPLAY_PRICE_SCHEDULE);
    // //   },
    // //   button_key: "F12",
    // },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "initData") {
      const { selectMode, data: paramData } = data;
      console.log("external data", paramData, selectMode);
      setLookupType("external");
      setSelectParams(paramData.params);
      setParamsData(paramData.paramsData);
      setIsFrescheJump(paramData.isFrescheJump || false);
      // setSelectedPatient([...paramData.selectedSchedule]);
      //setSelectMode(selectMode);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
        if (rowData.hasOwnProperty(key["target"])) {
          paramDataMap.set(key["source"], rowData[key["target"]]);
        }
      });
      const paramData = Object.fromEntries(paramDataMap);
        if (lookupType !== "external") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        if (lookupType === "external" && isFrescheJump) {
          const message = {
            type: "navigateData",
            data: { ...rowData },
            target: "RCMSG008",
          };
          return window.parent?.postMessage(message, "*");
        }
        const message = {
          message: "navigate-to-presto",
          programCode: "RCMSG008",
          parameters: {
            msgMessageCde: rowData["code"],
          },
        };
        window.top?.postMessage(message, "*");
      },
    },
    // {
    //   label: "Display",
    //   icon: <span className="material-icons">visibility</span>,
    //   command: () => {
    // },
    // }
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Message Code",
      field: "code",
    },
    {
      header: "Message",
      field: "message",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "code";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcmsgp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, selectedOption, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcmsgp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    setSelectedOption,
    leftButtons,
  };
};

export default useSelectMessage;
